import axios from 'axios'

//创建axios实例，封装成request简写代码
const request = axios.create({
    // `baseURL` 将自动加在 `url` 前面，除非 `url` 是一个绝对 URL。
    // 它可以通过设置一个 `baseURL` 便于为 axios 实例的方法传递相对 URL
    baseURL: 'https://inspectapi.zhiyanglao.cn',
    // baseURL: 'http://139.9.190.227:8003',
    // 如果请求花费了超过 `timeout` 的时间，请求将被中断
    timeout: 8000
})

// request 拦截器
// 可以自请求发送前对请求做一些处理
// 比如统一加token，对请求参数统一加密
request.interceptors.request.use(config => {
    config.headers['Content-Type'] = 'application/json;charset=utf-8';
    // config.headers['token'] = user.token;  // 设置请求头
    return config
}, error => {
    return Promise.reject(error)
});

let tokenFlag = false
// response 拦截器
// 可以在接口响应后统一处理结果
request.interceptors.response.use(
    response => {
        let res = response.data;
        let userRole = localStorage.getItem("userRole")

        if (res.code == 1 && !tokenFlag) {
            tokenFlag = true
            return location.href = '/login'
        }
        if ((userRole == '' || userRole == null) && location.href.indexOf('login') < 0 && !tokenFlag) {
            tokenFlag = true
            return location.href = '/login'
        }
        
        // 如果是返回的文件
        if (response.config.responseType === 'blob') {
            return res
        }
        // 兼容服务端返回的字符串数据
        if (typeof res === 'string') {
            res = res ? JSON.parse(res) : res
        }
        return res;
    },
    error => {
        console.log('err:' + error) // for debug
        return Promise.reject(error)
    }
)
export default request
